import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  surfaceTableHeader: {
    display: "grid",
    gridTemplateRows: "46px 88px",
    borderLeft: "1px solid",
    position: "relative",
    top: -2,
    boxShadow: "2px 0px 7px 0px rgba(0, 0, 0, 0.15)"
  },
  surfaceType: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    fontSize: 16,
    fontWeight: 700,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  dirt: {
    borderBottom: "2px solid #de7d16",
    backgroundColor: "rgba(222, 125, 22, 0.2)"
  },
  turfAndSynthetic: {
    borderBottom: "2px solid #1a8c00",
    backgroundColor: "rgba(26, 140, 0, 0.2)"
  },
  horseTypes: {
    display: "grid",
    gridTemplateColumns: "89px 570px"
  },
  horseType: {
    height: "100%",
    display: "grid",
    gridTemplateRows: "1fr 1fr"
  },
  horseTypesDetails: {
    display: "grid",
    gridTemplateColumns: "162px 204px 204px"
  },
  total: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: "#232323",
    fontSize: 12,
    fontWeight: 700
  },
  activeDetails: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr"
  },
  yearsDetails: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)"
  },
  narrowBorderTop: {
    borderTop: "1px solid #797979"
  },
  headCell: {
    height: 44,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    color: "#232323",
    fontSize: 12,
    fontWeight: 700
  },
  unitedTotalCell: {
    display: "grid",
    gridTemplateRows: "1fr 1fr"
  },
  dirtDashedBorder: {
    position: "relative",
    "&:before": {
      display: "block",
      content: "''",
      borderLeft: "2px solid #de7d16",
      height: 32,
      position: "absolute",
      left: 0
    }
  },
  turfAndSyntheticDashedBorder: {
    position: "relative",
    "&:before": {
      display: "block",
      content: "''",
      borderLeft: "2px solid #1a8c00",
      height: 32,
      position: "absolute",
      left: 0
    }
  }
});
